export default __webpack_public_path__ + "static/media/Hood of the Swift Talon.af6002a7.jpg";